import { Rating } from 'react-simple-star-rating';

const Rate = ({ value, count, size = 26, disabled = false, onChange, fillColor = '#27AE60', emptyColor = '#DDDDDD' }) => (
  <Rating
    size={size}
    iconsCount={count}
    fillColor={fillColor}
    emptyColor={emptyColor}
    readonly={disabled}
    emptyStyle={{ borderWidth: 1, borderColor: emptyColor }}
    style={{ borderWidth: 1, borderColor: emptyColor }}
    ratingValue={value}
    onClick={(value) => (onChange ? onChange(value) : {})}
  />
);

export default Rate;
